export const SET_STATUS = 'status:setStatus'
export const CLEAR_STATUS = 'status:clearStatus'
export const SET_SERVER_STATUS = 'status:setServerStatus'